(function(){
    'use strict'

    angular.module('app.turnos')
    .factory('TurnosService', TurnosService);

    TurnosService.$inject = ['$http', '$q', 'apiSettings'];

    function TurnosService($http, $q, apiSettings) {

        var api = {
            getAll: getAll,
            getById: getById,
            save: save,
            update:update,
            remove: remove
        };

        return api;

        function getAll(){

            var url = apiSettings.apiBaseUrl + 'api/turnos';
            
            return $http.get(url)
            .then(getAllSuccess, getAllError);

            function getAllSuccess(response){
                return response.data;
            };

            function getAllError(error) {
                return $q.reject(error);
            }
        };

        function getById(turnoId){

            var url = apiSettings.apiBaseUrl + 'api/turnos/' + turnoId;
            
            return $http.get(url)
            .then(getByIdSuccess, getByIdError);

            function getByIdSuccess(response){
                return response.data;
            };

            function getByIdError(error) {
                return $q.reject(error);
            }
        };

        function save(turno){

            turno.id = 0;

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/turnos',  
                method: 'POST',  
                data: turno
            });  
            return response;
        };

        function update(turno){

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/turnos',  
                method: 'PUT',  
                data: turno
            });  
            return response;
        };

        function remove(turno){

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/turnos',  
                method: 'DELETE', 
                headers: { 
                    'Content-Type': 'application/json' },
                data: turno
            });  
            return response;
        };

    };

})();